module.exports = __webpack_public_path__ + "static/media/overview_3.5c32db67.png";